import {
  AuthFormInput2,
  AuthFormInputSpan2,
  Body,
  Cell,
  CellTitle,
  CellValue,
  Footer,
  FormButton2,
  Row,
  Title,
} from "./styles";
import { ContainerRow } from "../../../../../components/Container";
import {
  formatCurrency,
  postWithdrawCancel,
  postWithdrawSendCode,
} from "../../../../../services/app";
import React, { useEffect, useState } from "react";
import { useApp } from "../../../../../contexts";
import { Sendcode } from "../../../../auth/styles";
import FormButton from "../../../../../components/FormCustom2/Button";
import { Copy } from "../../../../../components/Copy";

export default function ModalCancel(props) {
  const { T, currencies, setLoading } = useApp();
  const onClose = props.onClose;
  const [row, setRow] = useState({ ...(props.value || {}) });
  const [sentOtp, setSentOtp] = useState(0);
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const errors = {
    member_password_invalid: T("Member Password Invalid"),
    member_not_found: T("Member Not Found"),
    member_verification_code_invalid: T("Member Verification Code Invalid"),
    default: T("Error while making the request!"),
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        return prevState;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const getNameByCode = (code) => {
    return (currencies || []).find((item) => item.code === code)?.name || "";
  };

  const onSentOtp = async () => {
    setLoading(true);
    const result = await postWithdrawSendCode(row.id);
    if (result.status === 200) {
      setSentOtp(180);
    } else {
    }
    setLoading(false);
  };

  const onSubmit = async () => {
    setLoading(true);
    const result = await postWithdrawCancel({
      transactionId: row?.id,
    });
    if (result.status === 200) {
      onClose("success");
    } else {
      onClose("error");
    }
    setLoading(false);
  };

  return (
    <>
      <Title>{T("Cancel Withdrawal Request")}</Title>
      {row ? (
        <Body>
          <Row>
            <Cell>
              <CellTitle>{T("Transaction ID")}</CellTitle>
              <CellValue>{row?.code}</CellValue>
            </Cell>
          </Row>
          <Row>
            <Cell>
              <CellTitle>{T("Coin")}</CellTitle>
              <CellValue>
                {getNameByCode(row?.dest_currency_code)} (
                {row?.dest_currency_code || ""})
              </CellValue>
            </Cell>
          </Row>
          <Row>
            <Cell>
              <CellTitle>{T("Recipient’s Address")}</CellTitle>
              <CellValue className="text-ellipsis">
                <Copy
                  icon={<icon></icon>}
                  splitFontLg={40}
                  splitFont={25}
                  splitEnd={0}
                  numDot={3}
                  text={row?.dest_wallet_address || ""}
                ></Copy>
                {}
              </CellValue>
            </Cell>
          </Row>
          <Row>
            <Cell>
              <CellTitle>{T("Amount")}</CellTitle>
              <CellValue>
                {formatCurrency(row?.amount || "")}{" "}
                {row?.dest_currency_code || ""}
              </CellValue>
            </Cell>
          </Row>
          <Row style={{ marginTop: 0, marginBottom: 12 }}>
            <Cell>
              <CellTitle>{T("Fee")}</CellTitle>
              <CellValue>
                {formatCurrency(row?.fee_amount || "")}{" "}
                {row?.dest_currency_code || ""}
              </CellValue>
            </Cell>
          </Row>
          <Row style={{ marginTop: "30px" }}>
            <Cell>
              <CellTitle>{T("Confirm Password")}</CellTitle>
              <CellValue style={{ border: "none" }}>
                <AuthFormInput2
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder={T("Enter your password")}
                />
              </CellValue>
            </Cell>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Cell>
              <CellTitle>{T("Enter Verification Code")}</CellTitle>
              <CellValue style={{ border: "none" }}>
                <div style={{ position: "relative", flex: 1 }}>
                  <AuthFormInput2
                    value={otp}
                    onChange={(event) => setOtp(event.target.value)}
                    readOnly={sentOtp <= 0}
                    placeholder={
                      sentOtp <= 0
                        ? T("Click “Send Code”")
                        : T("Please enter code")
                    }
                  />
                  <AuthFormInputSpan2
                    style={{ top: 13 }}
                    onClick={() => {
                      if (sentOtp <= 0) {
                        onSentOtp().then();
                      }
                    }}
                  >
                    {sentOtp > 0 ? (
                      `${sentOtp}s`
                    ) : (
                      <div className="lg:mt-[2px] mt-3">
                        <Sendcode
                          className={
                            "auth absolute right-0 lg:bottom-[-22px] bottom-[-15px] w-[100px]"
                          }
                        >
                          {T("Send Code")}
                        </Sendcode>
                      </div>
                    )}
                  </AuthFormInputSpan2>
                </div>
              </CellValue>
            </Cell>
          </Row>
        </Body>
      ) : null}
      <Footer>
        <ContainerRow>
          <FormButton
            className={
              "black lg:w-[192px] lg:h-[52px] w-[280px] h-[50px] shadow-none lg:mb-0 mb-[15px] lg:mr-[15px]"
            }
            onClick={onClose}
          >
            {T("Cancel")}
          </FormButton>
          <FormButton2
            className={
              "lg:w-[192px] lg:h-[52px] w-[280px] h-[50px] shadow-none "
            }
            onClick={() => onSubmit()}
          >
            {T("Cancel transaction[button]")}
          </FormButton2>
        </ContainerRow>
      </Footer>
    </>
  );
}
